/**
 * Dial codes for certification phone OTP (E.164). Labels for UI only.
 * @typedef {{ dial: string, label: string, compact: string }} CertificationDialOption
 */

function buildCompactDialLabel(label, dial) {
  let country = String(label || '')
    .replace(/\s*\(\+[^)]+\)\s*$/, '')
    .trim()
  const slash = country.indexOf(' / ')
  if (slash > 0) country = country.slice(0, slash).trim()
  const budget = Math.max(3, 14 - dial.length - 1)
  const short =
    country.length > budget ? `${country.slice(0, Math.max(1, budget - 1))}…` : country
  return `${dial} ${short}`.trim()
}

/** @type {Omit<CertificationDialOption, 'compact'>[]} */
const UNSORTED = [
  { dial: '+1', label: 'United States / Canada (+1)' },
  { dial: '+7', label: 'Russia / Kazakhstan (+7)' },
  { dial: '+20', label: 'Egypt (+20)' },
  { dial: '+27', label: 'South Africa (+27)' },
  { dial: '+30', label: 'Greece (+30)' },
  { dial: '+31', label: 'Netherlands (+31)' },
  { dial: '+32', label: 'Belgium (+32)' },
  { dial: '+33', label: 'France (+33)' },
  { dial: '+34', label: 'Spain (+34)' },
  { dial: '+39', label: 'Italy (+39)' },
  { dial: '+41', label: 'Switzerland (+41)' },
  { dial: '+43', label: 'Austria (+43)' },
  { dial: '+44', label: 'United Kingdom (+44)' },
  { dial: '+45', label: 'Denmark (+45)' },
  { dial: '+46', label: 'Sweden (+46)' },
  { dial: '+47', label: 'Norway (+47)' },
  { dial: '+48', label: 'Poland (+48)' },
  { dial: '+49', label: 'Germany (+49)' },
  { dial: '+51', label: 'Peru (+51)' },
  { dial: '+52', label: 'Mexico (+52)' },
  { dial: '+54', label: 'Argentina (+54)' },
  { dial: '+55', label: 'Brazil (+55)' },
  { dial: '+60', label: 'Malaysia (+60)' },
  { dial: '+61', label: 'Australia (+61)' },
  { dial: '+62', label: 'Indonesia (+62)' },
  { dial: '+63', label: 'Philippines (+63)' },
  { dial: '+64', label: 'New Zealand (+64)' },
  { dial: '+65', label: 'Singapore (+65)' },
  { dial: '+66', label: 'Thailand (+66)' },
  { dial: '+81', label: 'Japan (+81)' },
  { dial: '+82', label: 'South Korea (+82)' },
  { dial: '+84', label: 'Vietnam (+84)' },
  { dial: '+86', label: 'China (+86)' },
  { dial: '+90', label: 'Türkiye (+90)' },
  { dial: '+91', label: 'India (+91)' },
  { dial: '+92', label: 'Pakistan (+92)' },
  { dial: '+94', label: 'Sri Lanka (+94)' },
  { dial: '+234', label: 'Nigeria (+234)' },
  { dial: '+254', label: 'Kenya (+254)' },
  { dial: '+351', label: 'Portugal (+351)' },
  { dial: '+353', label: 'Ireland (+353)' },
  { dial: '+852', label: 'Hong Kong (+852)' },
  { dial: '+880', label: 'Bangladesh (+880)' },
  { dial: '+966', label: 'Saudi Arabia (+966)' },
  { dial: '+971', label: 'United Arab Emirates (+971)' },
  { dial: '+972', label: 'Israel (+972)' },
  { dial: '+974', label: 'Qatar (+974)' },
  { dial: '+977', label: 'Nepal (+977)' },
]

export const CERTIFICATION_PHONE_DIAL_CODES = [...UNSORTED]
  .map((o) => ({ ...o, compact: buildCompactDialLabel(o.label, o.dial) }))
  .sort((a, b) => a.label.localeCompare(b.label, 'en'))

export const DEFAULT_CERTIFICATION_DIAL = '+91'

/**
 * @param {string} dial e.g. "+91"
 * @param {string} nationalRaw digits and optional separators
 * @returns {string} E.164 or "" if invalid
 */
export function buildE164FromDialAndNational(dial, nationalRaw) {
  const dialDigits = String(dial || '').replace(/\D/g, '')
  const nat = String(nationalRaw || '').replace(/\D/g, '')
  if (!dialDigits || !nat) return ''
  const combined = `${dialDigits}${nat}`
  if (combined.length < 10 || combined.length > 15) return ''
  return `+${combined}`
}
